// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const mediumRecipeId = (z.number());
export const mediumRecipe = z.object({
    id: mediumRecipeId,
    name: z.string(),
    version: z.string(),
    description: z.string().nullable(),
    changelog: z.string().nullable(),
    reference_weight_kg: z.string().nullable(),
    parent_recipe_id: mediumRecipeId.nullable(),
    is_locked: z.boolean(),
    owner_operator_id: operatorId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const mediumRecipeInitializer = z.object({
    id: mediumRecipeId.optional(),
    name: z.string(),
    version: z.string(),
    description: z.string().optional().nullable(),
    changelog: z.string().optional().nullable(),
    reference_weight_kg: z.string().optional().nullable(),
    parent_recipe_id: mediumRecipeId.optional().nullable(),
    is_locked: z.boolean().optional(),
    owner_operator_id: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const mediumRecipeMutator = z.object({
    id: mediumRecipeId.optional(),
    name: z.string().optional(),
    version: z.string().optional(),
    description: z.string().optional().nullable(),
    changelog: z.string().optional().nullable(),
    reference_weight_kg: z.string().optional().nullable(),
    parent_recipe_id: mediumRecipeId.optional().nullable(),
    is_locked: z.boolean().optional(),
    owner_operator_id: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=MediumRecipe.js.map